const THEME_DATA = [
  {
    id: 'contrast',
    name: 'Vivid',
    thumb_colors: [2, 1],
    colors: ['#EE8D24', '#43A5DA', '#6AB328', '#BB60F8', '#E14459', '#EAD022', '#06D0AD', '#DB38B7'],
    thumbnail: '',
  },
  {
    id: 'toughtea',
    name: 'Subdued',
    thumb_colors: [0, 2],
    colors: ['#D09B61', '#8BAF69', '#7395C2', '#B07DD0', '#CB6262', '#DED076', '#81C2B7', '#BF84B2'],
    thumbnail: '',
  },
  {
    id: 'rainbow',
    name: 'Rainbow Sherbet',
    thumb_colors: [3, 1],
    colors: [
      '#0482C1',
      '#F08E00',
      '#19B02B',
      '#E3352C',
      '#B86EC6',
      '#B06353',
      '#00C3D2',
      '#D4C500',
      '#E67FC8',
      '#A18D8D',
      '#BCD6DF',
      '#EEC37D',
      '#B7DB92',
      '#F0A5A1',
      '#D8B8D5',
      '#D8A89F',
      '#D8C9C9',
      '#E0D893',
      '#CAC9E0',
    ],
    thumbnail: '',
  },
  {
    id: 'candy',
    name: 'Candy',
    thumb_colors: [3, 1],
    colors: ['#8EC37E', '#F0C85B', '#3EA5E7', '#C16561', '#F67919'],
    thumbnail: '',
  },
  {
    id: 'colorblind',
    name: 'Colorblind Safe',
    thumb_colors: [3, 1],
    colors: ['#8853B8', '#C2A4DB', '#116578', '#6DC590', '#37B067'],
    thumbnail: '',
  },
  {
    id: 'monochrome',
    name: 'Monochrome',
    thumb_colors: [2, 0],
    colors: ['#459595', '#A0C9C9', '#367272', '#65D2CD', '#16BDBD'],
    thumbnail: '',
  },
  {
    id: 'pastel',
    name: 'Pastel',
    thumb_colors: [3, 5],
    colors: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f', '#e5c494', '#b3b3b3'],
    thumbnail: '',
  },
  {
    id: 'green',
    name: 'Green',
    thumb_colors: [3, 1],
    colors: ['#267B48', '#2E9356', '#37B067', '#6DC590', '#98D5B0'],
    thumbnail: '',
  },
  {
    id: 'blue',
    name: 'Blue',
    thumb_colors: [3, 1],
    colors: ['#0E819A', '#22A3C0', '#77C7D9', '#AEDEE9', '#D0ECF2'],
    thumbnail: '',
  },
  {
    id: 'orange',
    name: 'Orange',
    thumb_colors: [3, 1],
    colors: ['#A75126', '#C7612E', '#EE7437', '#F39E73', '#F6BA9D'],
    thumbnail: '',
  },
  {
    id: 'purple',
    name: 'Purple',
    thumb_colors: [3, 1],
    colors: ['#72429C', '#894FBA', '#A072C7', '#C2A4DB', '#D4BFE6'],
    thumbnail: '',
  },
  {
    id: 'gray',
    name: 'Gray',
    thumb_colors: [3, 1],
    colors: ['#2B2B2B', '#394242', '#646C6C', '#95A1A1', '#C3CBCB'],
    thumbnail: '',
  },
];

for (const theme of THEME_DATA) {
  const color1 = theme.colors[theme.thumb_colors[0]];
  const color2 = theme.colors[theme.thumb_colors[1]];
  theme.thumbnail = [
    'border-top-color:',
    color1,
    ';border-left-color:',
    color1,
    ';border-right-color:',
    color2,
    ';border-bottom-color:',
    color2,
    ';',
  ].join('');
}

export { THEME_DATA };
